import { objectfyArray } from "../helpers/objectfyArray";

const coupons = (state = {}, action) => {
  Object.freeze(state);
  let newState;
  switch (action.type) {
    case "SET_COUPONS":
      if (Array.isArray(action.coupons)) {
        return objectfyArray(action.coupons);
      } else {
        return action.coupons;
      }
    case "SET_COUPON":
      return {
        ...state,
        [action.coupon.id]: action.coupon,
      };
    case "REMOVE_COUPONS":
      return {};
    case "REMOVE_COUPON":
      newState = {
        ...state,
      };
      delete newState[action.coupon.id];
      return newState;
    case "ADD_TEMP_COUPON":
      return {
        ...state,
        newCoupon: {
          id: "newCoupon",
          minimumOrderValue: null,
          finePrint: "",
          maxRedemptions: null,
          maxRedemptionsPerUser: null,
          maxDiscount: null,
          amountOff: null,
          percentOff: null,
          code: "",
          expiration: null,
          isPublic: false,
        },
      };
    case "UPDATE_TEMP_COUPON":
      newState = {
        ...state,
      };
      delete newState.newCoupon;
      return {
        ...newState,
        [action.coupon.id]: action.coupon,
      };
    case "UPDATE_COUPON":
      newState = {
        ...state,
      };
      newState[action.coupon.id] = action.coupon;
      return newState;
    default:
      return state;
  }
};

export default coupons;
